/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferCount
 */
export interface OfferCount {
    /**
     * 
     * @type {number}
     * @memberof OfferCount
     */
    offerCount: number;
}

export function OfferCountFromJSON(json: any): OfferCount {
    return OfferCountFromJSONTyped(json, false);
}

export function OfferCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerCount': json['offerCount'],
    };
}

export function OfferCountToJSON(value?: OfferCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerCount': value.offerCount,
    };
}


